import { defineMessages } from 'react-intl';

export default defineMessages({
    addLocationButton: {
        id: 'wmic-pe-capability-gateway-common-ho-react.components.WMICHOCoverages.WMICHODesignatedPremisesLiabilityCov.WMICHODesignatedPremisesLiabilityCov.Add Location',
        defaultMessage: 'Add Location',
    },
    location: {
        id: 'wmic-pe-capability-gateway-common-ho-react.components.WMICHOCoverages.WMICHODesignatedPremisesLiabilityCov.WMICHODesignatedPremisesLiabilityCov.Location',
        defaultMessage: 'Location',
    },
    oneLocationRequired: {
        id: 'wmic-pe-capability-gateway-common-ho-react.components.WMICHOCoverages.WMICHODesignatedPremisesLiabilityCov.WMICHODesignatedPremisesLiabilityCov.Minimum of one Location required',
        defaultMessage: 'Minimum of one Location required',
    },
});
